import { GiReceiveMoney } from "react-icons/gi";
import {
  RiMoneyDollarCircleLine,
  RiUserReceivedLine,
  RiUserSharedLine,
} from "react-icons/ri";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { VscTriangleRight } from "react-icons/vsc";
import { MdDeleteForever } from "react-icons/md";
import { get, useForm } from "react-hook-form";
import { useRemmitances } from "../../../../hooks/useRemmitances";
import { useClient } from "../../../../hooks/useClient";
import Swal from "sweetalert2";
import React,{ useContext, useEffect, useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import "./VerticalStepper.css";
import SelectSearch from "../../../../components/ui/SelectSearch";
import NotifyC from "../../../../components/Notifications";
import { getUser,formatCurrency, getRemittanceType, printInvoice, normalizeIdNumber, idFormats, validateIdFormat,  provincesPrefix,updateFullId } from "../../../../utils/Common";
import { FaCheckCircle, FaLockOpen } from "react-icons/fa";
import Spinner from "../../../../components/Spinner";
import AuthContext from "../../../../contexts/auth";
import LockScreen from "../../../../components/ui/LockScreenCash"


const VerticalStepper = () => {
  const user = getUser();
  const { createNewRemmitances, getListMethodPayment, getListOffices , getComission, getRemmitancesByFilter } = useRemmitances();
  const { getClientById } = useClient();
  const [officeSelected, setOfficeSelected] = useState("");
  const [methodPaymentIdSelected,   setMethodPaymentIdSelected] = useState("");
  const [methodPaymentAmountSelected, setMethodPaymentAmountSelected] = useState("");
  const [paymentsSelectedList, setPaymentsSelectedList] = useState([]);
  const [listOffice, setListOffice] = useState([]);
  const [listPaymentMethod, setListPaymentMethod] = useState([]);
  const [feeValue, setFeeValue] = useState(0); 
  const [transmissionFee, setTransmissionFee] = useState(0); 
  const [remittanceType, setRemittanceType] = useState(""); 
  const [remittanceTypeOptions, setRemittanceTypeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const contentRef = useRef();
  const [idTypeSender, setIdTypeSender] = useState("cedula");
  const [idTypeRecipient, setIdTypeRecipient] = useState("cedula");
  const [loadingInputs, setLoadingInputs] = useState({ sender: false, recipient: false });
  const [idPrefixSender, setIdPrefixSender] = useState(null);
  const [idPrefixRecipient, setIdPrefixRecipient] = useState(null);
  const idOptions = idFormats();
  const idProvinces = provincesPrefix();

  const {
    register,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sender: { firstName: "", lastName: "", identification: "", email: "", phone: "", address: "" },
      recipient: { firstName: "", lastName: "", identification: "", email: "", phone: "", address: "" },
      remittance: { typeRemittance:"", office: "", amount: "", fee: "", cajaDropdown: "" }
    },
  });

  const [controlStep, setControlStep] = useState({
    senderStep: false,
    recipientStep: false,
    remittanceStep: false,
    submitBtn: false,
  });

  const resetForm = () => {
    reset({
      sender: { firstName: "", lastName: "", identification: "", email: "", phone: "", address: "" },
      recipient: { firstName: "", lastName: "", identification: "", email: "", phone: "", address: "" },
      remittance: { typeRemittance: "", office: "", amount: "", fee: "", cajaDropdown: "" },
    });
  
    setControlStep({
      senderStep: false,
      recipientStep: false,
      remittanceStep: false,
      submitBtn: false,
    });
  
    setOfficeSelected("");
    setPaymentsSelectedList([]);
    setMethodPaymentIdSelected("");
    setMethodPaymentAmountSelected("");
    setRemittanceType("");
    setIdTypeRecipient("cedula");
    setIdTypeSender("cedula");
    setLoadingInputs({ sender: false, recipient: false });
    setFeeValue(0);
    setTransmissionFee(0);
    setSelectedValue(null);
  };

  const handlePrintPDF = async (IdRemesa, copyNumber, deliver) => {
    const content = contentRef.current;
  
    if (!content) return;

    const dataToSend = { numRemittance: `${IdRemesa}` };
    const response = await getRemmitancesByFilter(new AbortController().signal, dataToSend);
 
    if (response?.code === 200) {
      const remesa = response.payload[0];
      const pdfBlob = await printInvoice(remesa, copyNumber, deliver);
        
          if (pdfBlob) {
            const pdfURL = URL.createObjectURL(pdfBlob);
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = pdfURL;
            document.body.appendChild(iframe);
        
            iframe.onload = () => {
              iframe.contentWindow.print();
            };
          }
    }
  };
  
  const confirmCopyPrint = async (message) => {
    const result = await Swal.fire({
      title: message,
      icon: "info",
      showCancelButton: false,
      confirmButtonText: "Imprimir",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        confirmButton: "custom-confirm-button",
      },
    });
    return result.isConfirmed;
  };

  const confirmAction = async (message) => {
    const result = await Swal.fire({
      title: "¡Atención!",
      html: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "white",
      cancelButtonColor: "black",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
          confirmButton: 'custom-confirm-button',
          cancelButton: 'custom-cancel-button',
      },
    });
    return result.isConfirmed;
  };

  const getClientData = async (IdType, IdNumber) => {
    const abortController = new AbortController();
    const data = {
      tipoDocumento: IdType,
      numDocumento: IdNumber,
    };
    try {
      const response = await getClientById(abortController.signal, data);
      if (response && response.length > 0) {
        return response[0]; 
      }
      return null;
    } catch (error) {
      NotifyC.error("Error al obtener los datos del cliente", { duration: 6000 });
      return null;
    }
  }

  
  const handleOnSubmit = async (data) => {

      const idSender = updateFullId(idPrefixSender, data.sender.identification, idTypeSender);
      const idRecipient = updateFullId(idPrefixRecipient, data.recipient.identification, idTypeRecipient);

      if (validateIdFormat(idSender, idTypeSender) === false) {
        NotifyC.error("El número de identificación del remitente no es válido", { duration: 6000 });
        return;
      }else if (validateIdFormat(idRecipient,idTypeRecipient) === false) {
        NotifyC.error("El número de identificación del destinatario no es válido", { duration: 6000 });
        return;
      }else if (data.remittance.amount <= 0) {
        NotifyC.error("El monto a enviar debe ser mayor a 0", { duration: 6000 });
        return;
      }
      if (!await confirmAction("¿Estás seguro de registrar el giro?")) return;
  
      setIsLoading(true);
      const dataSend = {
          ...data,
          sender: {
              ...data.sender,
              identification: idSender,
          },
          recipient: {
            ...data.recipient,
            identification: idRecipient,
          },
          remittance: {
              amount: Number(data.remittance.amount),
              fee: Number(feeValue),
              officeDestination: officeSelected,
              transmissionAmount: transmissionFee,
              remittanceTypeId: remittanceType,
              totalPayment: Number(data.remittance.amount) + Number(feeValue) + Number(transmissionFee),
          },
          methodsPayments: paymentsSelectedList,
          typeIdSender: idTypeSender,
          typeIdRecipient: idTypeRecipient,
      };
  
      try {
          const response = await createNewRemmitances(new AbortController().signal, dataSend);
          setIsLoading(false);
          if (response?.code === 200) { 
            resetForm();           
            await Swal.fire({
              title: "¡Giro registrado!",
              text: "Se ha registrado el giro correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              allowEscapeKey: false,
              customClass: {
                  confirmButton: "custom-confirm-button",
              },
          });
              let printSuccess = false;
              do {
                  handlePrintPDF(response.payload.NumeroRemesa, 1, false);
                  const retry = await Swal.fire({
                      title: "¿La impresión fue exitosa?",
                      text: "Si hubo un problema (por ejemplo, falta de papel), puede intentar reimprimir.",
                      icon: "question",
                      showCancelButton: true,
                      confirmButtonText: "Sí",
                      cancelButtonText: "Reimprimir",
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      customClass: {
                          confirmButton: "custom-confirm-button",
                          cancelButton: "custom-cancel-button",
                      },
                  });
                  printSuccess = retry.isConfirmed;
              } while (!printSuccess);
  
              const copyPrintConfirmed = await confirmCopyPrint("Imprimir copia de oficinista");
              if (copyPrintConfirmed) {
                  let copyPrintSuccess = false;
                  do {
                      handlePrintPDF(response.payload.NumeroRemesa, 2, false);
                      const retryCopy = await Swal.fire({
                          title: "¿La impresión de la copia fue exitosa?",
                          text: "Si hubo un problema (por ejemplo, falta de papel), puede intentar reimprimir.",
                          icon: "question",
                          showCancelButton: true,
                          confirmButtonText: "Sí",
                          cancelButtonText: "Reimprimir",
                          allowOutsideClick: false,
                          allowEscapeKey: false,
                          customClass: {
                              confirmButton: "custom-confirm-button",
                              cancelButton: "custom-cancel-button",
                          },
                      });
                      copyPrintSuccess = retryCopy.isConfirmed;
                  } while (!copyPrintSuccess);
              }
     
          } else {
              const errorMessages = {
                  "CASHBOX_NOT_OPEN": "Ops, la caja se encuentra cerrada no se puede entregar giros.",
                  "UNAUTHORIZED_USER": "No tienes permiso para crear giros.",
                  "CASH_INFO_USER_NOT_FOUND": "No se encontró información de la caja.",
                  "ERROR_CREATING_REMITTANCE_CLIENTS": "Hubo un error al registrar la informacion de los clientes, intente nuevamente.",
                  "ERROR_CREATING_REMITTANCE": "Hubo un error al registrar el giro, intente nuevamente.",
                  "ERROR_CREATE_NEW_REMITTANCE": "Hubo un error al registrar el giro, intente nuevamente.",
                  "CASHBOX_NOT_ACTIVE": "Ops, la caja se encuentra desactivada no se puede entregar giros.",
                  "OFFICE_NOT_ACTIVE": "Ops, la estafeta se encuentra desactivada no se puede entregar giros.",
                };
              const message = errorMessages[response?.message] || "Hubo un problema de conexión o un error inesperado.";
              NotifyC.error(message, { duration: 6000 });
          }
      } catch (error) {
          setIsLoading(false);
          Swal.fire({
              title: "¡Error!",
              text: "Hubo un problema de conexión o un error inesperado.",
              icon: "error",
              confirmButtonText: "Ok",
              customClass: {
                  confirmButton: "custom-confirm-button",
              },
          });
      }
  };

  const validateSteps = () => {
      const senderValues = { ...watch("sender") };
      delete senderValues.email;
      delete senderValues.phone;
      delete senderValues.address;
    
      const recipientValues = { ...watch("recipient") };
      delete recipientValues.email;
      delete recipientValues.phone;
      delete recipientValues.address;
    
      const remittanceValues = { ...watch("remittance"), 
        office: officeSelected, 
        typeRemittance: remittanceType 
      };
    
      const senderCompleted = Object.values(senderValues).every(
        (field) => String(field).trim() !== ""
      );
      const recipientCompleted = Object.values(recipientValues).every(
        (field) => String(field).trim() !== ""
      );
      const remittanceCompleted = Object.values(remittanceValues).every(
        (field) => String(field).trim() !== ""
      );
    
      const totalPaid = paymentsSelectedList.reduce((acc, payment) => acc + Number(payment.amount), 0);
      const balance = (Number(remittanceValues.amount) + (Number(feeValue)) + (remittanceType === "2" ? transmissionFee : 0) - totalPaid);
      const methodPaymentCompleted = (balance <= 0 && paymentsSelectedList.length > 0) ? true : false;
      const amountToSend = Number(remittanceValues.amount);

      if (amountToSend > 1000) {
        setControlStep({
          remittanceStep: false,
          senderStep: false,
          recipientStep: false,
          submitBtn: false,
        });
        return;
      }
    
      setControlStep({
        remittanceStep: remittanceCompleted,
        senderStep: senderCompleted,
        recipientStep: recipientCompleted,
        submitBtn:
          remittanceCompleted &&
          senderCompleted &&
          recipientCompleted && 
          methodPaymentCompleted
      });
  };

  const handleIdChange = async (event, section, IdType, idPrefix) => {
    const idNumber = event.target.value;
    const normalizedId = normalizeIdNumber(idNumber, IdType); 
    event.target.value = normalizedId;

    const idNumberFull = updateFullId(idPrefix, normalizedId, IdType); 
  
    const length = IdType === "cedula" ? 7 : IdType === "extranjero" ? 12 : 6; 

    if (idNumberFull.length > length) {
      setLoadingInputs((prev) => ({ ...prev, [section]: true })); 
      const clientData = await getClientData(IdType, idNumberFull);
      setLoadingInputs((prev) => ({ ...prev, [section]: false }));
  
      if (clientData) {
        reset({
          ...watch(),
          [section]: {
            ...watch(section),
            firstName: clientData.NombreSimple || "",
            lastName: clientData.ApellidoSimple || "",
            email: clientData.Email || "",
            phone: clientData.Telefono || "",
            address: clientData.Direccion || "",
          },
        });
        NotifyC.success("Cliente encontrado", { duration: 3000 });
      } 
      validateSteps();
    }

  };
  
  const renderInput = (section, field, label, required, type, mask, setIdType, idType, setIdPrefix,idPrefix) => {
    return (
      <>   
        {!mask ? ( <>
          <div className="col-12 col-md-6 col-lg-3 form-group text-left">
            <label>
              {label} {required && <span className="text-danger">*</span>}
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={type ?? "text"}
                step={type === "number" ? "any" : undefined}	
                className="form-control"
                name={`${section}.${field}`}
                ref={register({
                  required: required ? "Este campo es obligatorio" : false,
                  validate: (value) =>
                    field === "amount" && Number(value) > 1000
                      ? "El límite de transacción es de 1,000"
                      : true,
                })}
                onChange={() => {
                  validateSteps();
                }}
                disabled={loadingInputs[section]}
              />
              {loadingInputs[section] && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                  }}
                >
                  <Spinner type={1} />
                </div>
              )}
            </div>
          {/* Mostrar errores */}
          {errors[section]?.[field] && (
              <span className="text-danger">{errors[section][field].message}</span>
            )}
            {/* Validación adicional para montos */}
          {field === "amount" && Number(watch(`${section}.${field}`)) > 1000 && (
          <span className="text-danger">
            El límite de transacción es de 1,000
          </span>
        )}
          </div>
       </> ) : (
          <div className="col-12 col-md-12 col-lg-6 form-group text-left">
            <label>
              Número de Identificación <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              {/* Select del tipo de identificación */}
              <div className="input-group-append">
                <SelectSearch
                  options={idOptions}
                  nameInput="idType"
                  setValue={(_, value) => setIdType(value)}
                  value={idType}
                  isRequired
                  className="form-control"
                  style={{ width: "auto" }}
                />
              </div>
  
              {["cedula-E", "cedula-N"].includes(idType) ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value={`${idType.split("-")[1]}-`}
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <div className="input-group-append">
                    <div className="input-group-append">
                      <SelectSearch
                        options={idProvinces}
                        nameInput="Prefix"
                        setValue={(_, value) => setIdPrefix(value)}
                        value={idPrefix}
                        isRequired
                        className="form-control"
                        style={{ width: "auto" }}
                      />
                    </div>
                  </div>
                  <span className="input-group-text">-</span>
                </>
              ) : idType === "cedula-PE" ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value="PE-"
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Prefijo"
                    value={idPrefix || ""}
                    onChange={(e) => setIdPrefix(e.target.value)}
                    style={{ maxWidth: "80px" }}
                  />
                  <span className="input-group-text">-</span>
                </>
              ) : ["cedula", "cedula-AV", "cedula-PI"].includes(idType) ? ( <> 
                <div className="ml-2">
                  <SelectSearch
                    options={idProvinces}
                    nameInput="Prefix"
                    setValue={(_, value) => setIdPrefix(value)}
                    value={idPrefix}
                    isRequired
                    className="form-control"
                    style={{ width: "auto" }}
                  />
                   
                </div>
                {["cedula"].includes(idType) &&( 
                  <span className="input-group-text">-</span>
                 )}
           
              </>) : null}
            
              <input
                type="text"
                placeholder={
                  idOptions.find((option) => option.value === idType)?.placeholder
                }
                className="form-control"
                name={`${section}.${field}`}
                ref={register()}
                onChange={(event) => {
                  handleIdChange(event, section, idType, idPrefix);
                  validateSteps();
                }}
              />
            </div>    
          {/* Mostrar errores */}
          {errors[section]?.[field] && (
            <span className="text-danger">{errors[section][field].message}</span>
          )}
          </div>
        )}
      </>
    );
  };
  

  const handleSelect = (name, value) => {
    if (name === "office") {
      setOfficeSelected(value);
    }

    if (name === "typePayment") {
      setSelectedValue(value);
      setMethodPaymentIdSelected(value);
    }

    if (name === "typeRemittance") {
      setRemittanceType(value);
    }

    if (name === "Prefix") {
      
    }
    validateSteps();
  };

  const handleGetListOffices = async () => {
    const abortController = new AbortController();
    const response = await getListOffices(abortController.signal);

    if (response?.length > 0) {
       setListOffice(response);
      } 
  };

  const handleGetListPaymentMethods = async () => {
    const abortController = new AbortController();
    const response = await getListMethodPayment(abortController.signal);
    setListPaymentMethod(response);
  };

  const [selectedValue, setSelectedValue] = useState(null);

  const handleResetSelect = () => {
    setSelectedValue(null);
    validateSteps();
  };

  const renderSelectorMethodPayment = () => {
    
    const amountRemmitance = Number(watch("remittance.amount"));
    const feeRemmitance = Number(watch("remittance.amount")) * feeValue;
    const totalRemmitance = Number(amountRemmitance) + Number(feeValue) + (remittanceType === "2" ? transmissionFee : 0); 

    const totalPaid = paymentsSelectedList.reduce((acc, payment) => acc + Number(payment.amount), 0);
    const balance = totalPaid < totalRemmitance ? (totalRemmitance - totalPaid) : 0;
    const change = totalPaid > totalRemmitance ? (totalPaid - totalRemmitance) : 0;

    
  const isCompleteMethodPayment = !methodPaymentIdSelected || !methodPaymentAmountSelected || methodPaymentAmountSelected <= 0;

  const isPaymentDisabled = balance === 0;   

    const handleSetTypePayment = () => {      
      if (isCompleteMethodPayment) { 
          if (!methodPaymentIdSelected) {
              NotifyC.error("No se ha seleccionado un método de pago", { duration: 5000 });
          }
  
          if (!methodPaymentAmountSelected) {
              NotifyC.error("No se ha ingresado un monto para el método de pago", { duration: 5000 });
          }
  
          if (methodPaymentAmountSelected <= 0) {
              NotifyC.error("El monto ingresado debe ser mayor a 0", { duration: 5000 });
          }
      } else {
          const selectedPaymentMethod = listPaymentMethod.find(payment => payment.value === methodPaymentIdSelected);
  
          if (selectedPaymentMethod) {
              const existingIndex = paymentsSelectedList.findIndex(payment => payment.value === methodPaymentIdSelected);
  
              if (existingIndex !== -1) {
                  setPaymentsSelectedList(prevMethods => {
                      const updatedMethods = [...prevMethods];
                      updatedMethods[existingIndex].amount = 
                          (Number(updatedMethods[existingIndex].amount) + Number(methodPaymentAmountSelected)).toFixed(2);
                      return updatedMethods;
                  });
              } else {
                  setPaymentsSelectedList(prevMethods => [
                      ...prevMethods, 
                      { 
                          ...selectedPaymentMethod, 
                          amount: Number(methodPaymentAmountSelected).toFixed(2)
                      }
                  ]);
              }
          }

          setMethodPaymentIdSelected("");
          setMethodPaymentAmountSelected("");
          handleResetSelect();
      }   
  };
  

  const handleDeletePayment = (index) => {
    const newPaymentsSelectedList = [...paymentsSelectedList];
    newPaymentsSelectedList.splice(index, 1);
    setPaymentsSelectedList(newPaymentsSelectedList);
  };

    return (
      <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-4 form-group text-left">
          <div className="card-dashed">
            <div className="card-dashed-header">
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>
                  <div>Monto a enviar</div>
                  <div className="text-bold">{formatCurrency(amountRemmitance)}</div>
                </div>

                <div className="text-bold">+</div>

                <div>
                  <div>Comisión ({feeValue})</div>
                  <div className="text-bold">{formatCurrency(feeValue)}</div>
                </div>
                
                  <>
                <div className="text-bold">+</div>
                <div>
                  <div>Transmisión</div>
                  <div className="text-bold">{formatCurrency(transmissionFee)}</div>
                </div> 
                </>
                
              </div>
            </div>
            <div className="card-dashed-body">
              <div>
                <label>
                  Elegir el método de pago{" "}
                  <span className="text-danger">*</span>
                </label>
                <SelectSearch
                  options={listPaymentMethod}
                  nameInput={"typePayment"}
                  setValue={handleSelect}
                  value={selectedValue}
                  isRequerid
                  isDisabled={isPaymentDisabled}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "1rem",
                }}
              >
                <input
                  type="number"
                  className="form-control"
                  placeholder={formatCurrency(0)}
                  style={{ width: "50%" }}
                  value={methodPaymentAmountSelected}
                  onChange={(e) => setMethodPaymentAmountSelected(e.target.value)}
                  disabled={isPaymentDisabled}
                />
                <button className="btn btn-blue" disabled={isCompleteMethodPayment} type="button" onClick={() => handleSetTypePayment()}>+ Agregar</button>
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 form-group text-left">
          <div className="card-dashed">
            <div className="card-dashed-header">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize:"16px", color:"#000000" }}>
                  <div className="text-bold">Saldo a pagar</div>
                  <div className="text-bold">{formatCurrency(totalRemmitance)}</div>
              </div>
            </div>
            <div className="card-dashed-body">
              <div className="list-content-payment">
                
                {
                paymentsSelectedList.length === 0 ? (
                  <span style={{color:"gray"}}><IoMdInformationCircleOutline size={16}/> No se han seleccionado metodos de pago</span>
                ) : (
                  paymentsSelectedList.map((payment, index) => (
                    <div key={index} className="item-list-payment">
                      <div className="d-flex">
                        <div onClick={()=> handleDeletePayment(index)}>
                          <MdDeleteForever size={20} color="red" />
                        </div>
                        <div className="item-title-list-payment">
                        <VscTriangleRight /> {payment.label}
                      </div>
                      </div>
                      <div className="item-value-list-payment">
                        - {formatCurrency(Number(payment.amount))}
                      </div>
                    </div>
                  ))
                )
                }

              </div>

              <div style={{
                borderTop: "1px solid #e3e3e3",
                paddingTop: "10px",
              }}>
                 <div className="list-content-payment">
                <div className="item-list-payment">
                    <div >
                      Cambio
                    </div>
                    <div className="text-bold">
                        {formatCurrency(change)}
                      </div>
                </div>
                <div className="item-list-payment">
                    <div>
                      Saldo Final
                    </div>
                    <div style={{
                      color:"#0C4271",
                      fontSize:"16px",
                    }} className="font-bold">
                      {formatCurrency(balance)}
                      </div>
                </div>
              </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  };

  const steps = [
    {
      label: "Información del Giro",
      icon: <GiReceiveMoney size={18} />,
      bgIcon: "#fbd825",
      colorIcon: "#000",
      content: (
        <div className="row mt-3">
          <div className="col-12 col-md-6 col-lg-3 form-group text-left">
            <label>
              Tipo de giro <span className="text-danger">*</span>
            </label>
            <SelectSearch
              options={remittanceTypeOptions}
              nameInput={"typeRemittance"}
              setValue={handleSelect}
              isRequerid
              value={remittanceType}
            />
          </div>

          <div className="col-12 col-md-6 col-lg-3 form-group text-left">
            <label>
              Estafeta destino <span className="text-danger">*</span>
            </label>
            <SelectSearch
              options={listOffice}
              nameInput={"office"}
              setValue={handleSelect}
              isRequerid
              value={officeSelected}
            />
          </div>

          {renderInput(
            "remittance",
            "amount",
            "Monto a enviar",
            true,
            "number"
          )}

          <div className="col-12 col-md-6 col-lg-2 form-group text-left">
            <label>
            Comisión 
            {/* ({(feeValue ).toFixed(0)}%) */}
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name={`remittance.fee`}
              placeholder=""
              value={
                watch("remittance.amount")
                  ? `${formatCurrency(feeValue)}`
                  : formatCurrency(feeValue)
              }
              disabled
              ref={register()}
            />
          </div>

          {remittanceType === "2" && (
          <div className="col-12 col-md-6 col-lg-2 form-group text-left">
            <label>
              Transmisión
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name={`remittance.transmission`}
              placeholder=""
              value={formatCurrency(transmissionFee)}
              disabled
              ref={register()}
            />
          </div>
        )}

                <div className="col-12 col-md-6 col-lg-2 form-group text-left">
          <label>
            Total a pagar<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={
                        watch("remittance.amount") > 0
                  ? `${formatCurrency(
                      parseFloat(watch("remittance.amount")) +
                      parseFloat(feeValue) +
                      parseFloat(transmissionFee)
                    )}`
                  : formatCurrency((remittanceType === "2" ? parseFloat(transmissionFee) : 0) + parseFloat(feeValue)) 
            }
            disabled
            ref={register()}
          />
        </div>
        </div>
      ),
    },
    {
      label: "Datos del Remitente",
      icon: <RiUserSharedLine size={18} />,
      content: (
        <div className="row mt-3">
            {renderInput(
            "sender",
            "identification",
            "No. Cédula o Pasaporte",
            true,
            null,
            true,
            setIdTypeSender,
            idTypeSender,
            setIdPrefixSender,
            idPrefixSender
          )}
          {renderInput("sender", "firstName", "Nombre", true)}
          {renderInput("sender", "lastName", "Apellido", true)}
   
          {renderInput("sender", "email", "Correo electrónico", false)}
          {renderInput("sender", "phone", "Teléfono", false)}
          {renderInput("sender", "address", "Dirección", false)}
        </div>
      ),
      bgIcon: "#0c4271",
    },
    {
      label: "Datos del Destinatario",
      icon: <RiUserReceivedLine size={18} />,
      content: (
        <div className="row mt-3">
          {renderInput(
            "recipient",
            "identification",
            "No. Cédula o Pasaporte",
            true,
            null,
            true,
            setIdTypeRecipient,
            idTypeRecipient,
            setIdPrefixRecipient,
            idPrefixRecipient
          )}
          {renderInput("recipient", "firstName", "Nombre", true)}
          {renderInput("recipient", "lastName", "Apellido", true)}
          {renderInput("recipient", "email", "Correo electrónico", false)}
          {renderInput("recipient", "phone", "Teléfono", false)}
          {renderInput("recipient", "address", "Dirección", false)}
        </div>
      ),
      bgIcon: "#e2131b",
    },
    {
      label: "Metodos de Pago",
      icon: <RiMoneyDollarCircleLine size={18} />,
      content: renderSelectorMethodPayment(),
      bgIcon: "gray",
    },
  ];

  useEffect(() => {
    validateSteps();
  }, [officeSelected, paymentsSelectedList]);

  useEffect(() => {
    handleGetListOffices();
    handleGetListPaymentMethods();
  }, []);

  useEffect(() => {
    const inputs = document.querySelectorAll('input[type="number"]');
    const preventScroll = (event) => event.preventDefault();
    inputs.forEach((input) => {
      input.addEventListener("wheel", preventScroll);
    });
    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("wheel", preventScroll);
      });
    };
  }, []);

  useEffect(() => {
    const ComissionData = async () => {
      const abortController = new AbortController();
      const response = await getComission(abortController.signal);
      const amount = Number(watch("remittance.amount"));
  
      if (response.length > 0) {
        const options = response.reduce((acc, comission) => {
          if (comission.Tipo === 1 && !acc.some(option => option.value === "1")) {
            acc.push({ value: "1", label: getRemittanceType(comission.Tipo) });
          } else if (comission.Tipo === 2 && !acc.some(option => option.value === "2")) {
            acc.push({ value: "2", label: getRemittanceType(comission.Tipo) });
          }
          return acc;
        }, []);
        setRemittanceTypeOptions(options);
  
        const groupedComissions = response.reduce((acc, comission) => {
          const comissionPostal = comission.Tipo === 1;
          const comissionTelegraphic = comission.Tipo === 2;
  
          if (remittanceType === "1" && comissionPostal) {
            acc.postal.push(comission);
          } else if (remittanceType === "2" && comissionTelegraphic) {
            acc.telegraphic.push(comission);
          }
          return acc;
        }, { postal: [], telegraphic: [] });
  
        const comissionPostal = groupedComissions.postal.find(
          comission => amount >= comission.MontoDesde && amount <= comission.MontoHasta
        );
  
        const comissionTelegraphic = groupedComissions.telegraphic.find(
          comission => amount >= comission.MontoDesde && amount <= comission.MontoHasta
        );
  
        if (comissionPostal) {
          setFeeValue(comissionPostal.MontoComision);
          setTransmissionFee(comissionPostal.Transmision);
        
        } else if (comissionTelegraphic) {
          setFeeValue(comissionTelegraphic.MontoComision);
          setTransmissionFee(comissionTelegraphic.Transmision);
        
        } else {
          setFeeValue(0);
          setTransmissionFee(0);
        }
      }
    };
  
    ComissionData();
  
    if (!remittanceType === "" || watch("remittance.amount") <= 0) {
      setFeeValue(0);
      return;
    }
  }, [watch("remittance.amount"), remittanceType]);

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      {steps.map((step, index) => (
        <div
          key={index}
          style={{ marginBottom: "20px", borderBottom: "1px dashed #e3e3e3" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                background: `${step.bgIcon}`,
                color: step.colorIcon ?? "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "10px",
              }}
            >
              {step.icon}
            </div>
            <span style={{ fontSize: "18px", fontWeight: "500" }}>
              {step.label}
            </span>
          </div>
          <CSSTransition
            in={
              index === 0 ||
              (index === 1 && controlStep.remittanceStep) ||
              (index === 2 && controlStep.senderStep) ||
              (index === 3 && controlStep.recipientStep)
            }
            timeout={200}
            classNames="step"
            unmountOnExit
          >
            <div className="px-4">{step.content}</div>
          </CSSTransition>
        </div>
      ))}

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
         <div ref={contentRef}>
      
      </div>
        <button
          type="submit"
          className="btn btn-blue"
          disabled={!controlStep.submitBtn || isLoading}
        >
           {isLoading ? <Spinner type={1} /> : <><FaCheckCircle /> Crear giro</> }
        </button>
      </div>
    </form>
  );
};

const RegisterRemittances = () => {
       
  return (
    <>
   <LockScreen title={"Caja cerrada"} description={"La caja se encuentra cerrada, no se puede realizar operaciones hasta su apertura"} />
      <div className="dashboardCard text-left" style={{ color: "black" }}>
        <div className="d-flex align-items-center" style={{ gap: 15 }}>
          <GiReceiveMoney size={25} />
          <h5 className="mb-0">Registrar giros</h5>
        </div>
      </div>

      <div className="dashboardCard">
        <VerticalStepper />
      </div>
    </>
  );
};

export default RegisterRemittances;
